export default __webpack_public_path__ + "static/media/synapse.ac27aceb.png";